import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Popover from "@material-ui/core/Popover";
import locale from "../../utils/locale"
import Icon from "@material-ui/core/Icon";

const styles = theme => ({
  typography: {
    margin: theme.spacing.unit * 2
  }
});

class SimplePopover extends React.Component {
  state = {
    anchorEl: null
  };

  handleClick = event => {
    this.setState({
      anchorEl: event.currentTarget
    });
  };

  handleClose = () => {
    this.setState({
      anchorEl: null
    });
  };

  render() {
    const { classes, img, heading } = this.props;
    const { anchorEl } = this.state;

    return (
      <span>
        <Icon onClick={this.handleClick} style={{ fontSize: 14 }}>
          {locale("info")}
        </Icon>
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center"
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "right"
          }}
        >
          <h2 className="pop-heading">{heading}</h2>
          <img src={img} width="273" height="155"/>
        </Popover>
      </span>
    );
  }
}

SimplePopover.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SimplePopover);



// WEBPACK FOOTER //
// ./src/components/form/SimplePopover.js